import { CustomerDocumentType } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const customerDocumentTypeMessages = defineMessages({
  idCard: {
    defaultMessage: 'ID card',
    description: 'customer document type title',
  },
  npwpCard: {
    defaultMessage: 'NPWP',
    description: 'customer document type title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'customer document type title',
  },
  otherWithOtherType: {
    defaultMessage: 'Other ({otherType})',
    description: 'customer document type title',
  },
})

export function translateCustomerDocumentType(
  intl: IntlShape,
  type: CustomerDocumentType,
  otherType: string | null,
): string {
  switch (type) {
    case CustomerDocumentType.ID_CARD:
      return intl.formatMessage(customerDocumentTypeMessages.idCard)
    case CustomerDocumentType.NPWP_CARD:
      return intl.formatMessage(customerDocumentTypeMessages.npwpCard)
    case CustomerDocumentType.OTHER:
      if (otherType) {
        return intl.formatMessage(customerDocumentTypeMessages.otherWithOtherType, {
          otherType,
        })
      } else {
        return intl.formatMessage(customerDocumentTypeMessages.other)
      }
  }
}
